
const Protocols = {
  HTTP: 'http:',
  HTTPS: 'https:',
};

export function getPurePosition() {
  return new Promise( (resolve, reject) => {
    if( navigator && navigator.geolocation && navigator.geolocation.getCurrentPosition) {
      navigator.geolocation.getCurrentPosition( resolve, reject);
    } else {
      reject({ message: 'Error, geolocalizacion a traves de html5 no disponible.' });
    }
  });
}

export async function uniqueGetPurePosition() {
  if( uniqueGetPurePosition.cached) return uniqueGetPurePosition.cached;
  else return uniqueGetPurePosition.cached = await getPurePosition();
}

export function getPosition() {
  if( window.location.protocol === Protocols.HTTP) {
    window.location.replace( window.location.href.replace( /^http:/, 'https:'));
  } else return uniqueGetPurePosition();
}
